const HEIC_TYPES = new Set(["image/heic", "image/heif", "image/heic-sequence", "image/heif-sequence"]);
const HEIC_EXTENSIONS = /\.(heic|heif)$/i;

/**
 * Convert HEIC files to JPEG blobs using heic2any.
 * Non-HEIC files pass through unchanged.
 * @param {File[]} files
 * @param {{ dropFailed?: boolean, onError?: (file: File, error: unknown) => void }} [options]
 * @returns {Promise<File[]>}
 */
export async function convertHeicFiles(files, options = {}) {
  const { dropFailed = false, onError } = options;
  const results = [];
  for (const file of files) {
    if (isHeicFile(file)) {
      try {
        const { default: heic2any } = await import("heic2any");
        const blob = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 });
        const jpegBlob = Array.isArray(blob) ? blob[0] : blob;
        const converted = new File([jpegBlob], file.name.replace(HEIC_EXTENSIONS, ".jpg"), {
          type: "image/jpeg",
          lastModified: file.lastModified,
        });
        results.push(converted);
      } catch (error) {
        if (onError) onError(file, error);
        if (!dropFailed) results.push(file);
      }
    } else {
      results.push(file);
    }
  }
  return results;
}

export function isHeicFile(file) {
  return HEIC_TYPES.has(file.type) || HEIC_EXTENSIONS.test(file.name);
}
